/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_Sections_TitleInputs */

const fr_session_sections_title = /** @type {(inputs: Session_Sections_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sections de la session`)
};

/**

* @param {Session_Sections_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const session_sections_title = /** @type {((inputs?: Session_Sections_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_Sections_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_session_sections_title(inputs)
});